import { callExternalApi, CallResult } from '../callExternalApi';
import { ReportTab, ReportViewConfig } from '../Report/reportApi';

export type ReportTableType =
  | 'inventory'
  | 'project'
  | 'related_project_assets'
  | 'order'
  | 'case'
  | 'default'
  | string;
// Expired outranks paused: a schedule whose end date has passed will never run again, resumed or not.
export type ReportStatus = 'active' | 'paused' | 'expired';

export interface ReportListItem {
  id: string;
  view_name: string;
  table_type: ReportTableType;
  tab_count?: number;
  frequency: string | null;
  last_run: string | null;
  next_scheduled: string | null;
  status: ReportStatus;
  owned?: boolean;
  received?: boolean;
}

export interface ReportRunDescriptor {
  id: string;
  run_date: string;
}

export interface ReportRun extends ReportRunDescriptor {
  content: Record<string, unknown>[];
}

export interface ReportDetail {
  id: string;
  view_name: string;
  table_type: ReportTableType;
  view_config: ReportViewConfig | null;
  tabs?: ReportTab[];
  tab_count?: number;
  runs: ReportRunDescriptor[];
  latest_run: ReportRun | null;
}

export interface ReportRunPayload {
  id: string;
  run_date: string;
  content: Record<string, unknown>[];
  view_config: ReportViewConfig | null;
  tabs?: ReportTab[];
  view_name: string;
  table_type: ReportTableType;
}

export const getReports = async (accountIds?: string[]): Promise<CallResult<ReportListItem[]>> => {
  if (!accountIds?.length) return { data: null, error: { message: 'Must provide account IDs' } };
  return callExternalApi<ReportListItem[]>({
    url: `api/reports?account_ids=${accountIds.join(',')}&include_owned=true`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getReport = async (id: string): Promise<CallResult<ReportDetail>> => {
  return callExternalApi<ReportDetail>({
    url: `api/reports/${id}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getReportRun = async (id: string, runId: string): Promise<CallResult<ReportRunPayload>> => {
  return callExternalApi<ReportRunPayload>({
    url: `api/reports/${id}/runs/${runId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
